import React from "react";
import FunnelInsightCard from "./FunnelInsightCard";
import { buildFixedCostViabilityChart } from "./funnelChartUtils";
import {
  cleanLines,
  extractTitle,
  stripTitleLines,
  extractTableBlock,
  splitByHeading,
  toBullets,
  toParagraphs,
  extractVerdict,
} from "./funnelUtils";

const FunnelFixedCostViability = ({ markdown = "" }) => {
  const title = extractTitle(markdown) || "Fixed Cost Viability";
  const lines = stripTitleLines(cleanLines(markdown));
  const { table, before, after } = extractTableBlock(lines);
  const chart = buildFixedCostViabilityChart(table);
  const { tail } = splitByHeading(after, "What Does This Mean?");
  const bullets = toBullets(tail);
  let paragraphs = toParagraphs(tail);
  const verdict = extractVerdict(paragraphs);
  if (verdict) paragraphs = paragraphs.slice(0, -1);

  return (
    <FunnelInsightCard
      title={title}
      kicker="Operating Leverage"
      sections={[
        {
          title: "Fixed Cost Diagnostic",
          chart,
          chartTitle: "Fixed Cost Load",
          chartSubtitle:
            "This makes breakeven pressure visible instead of burying it in rows.",
          table,
          paragraphs: before.length ? toParagraphs(before) : [],
        },
        {
          title: "What Does This Mean?",
          bullets,
          paragraphs,
          verdict,
        },
      ]}
    />
  );
};

export default FunnelFixedCostViability;
